/* eslint-disable react-hooks/exhaustive-deps */
import { ErrorMessage, Field, FormikProvider, useFormik } from 'formik'
import { KTSVG } from '../../../../../_metronic/helpers'
import { DropzoneComponent, useAlert, useHelper, useHttpClient } from '../../../../modules/services/Bundle'
import { RequestMethod } from '../../../../modules/services/core/_enums'
import { defaultCarregarCargos, defaultValidationSchemas, modeloValidationSchema } from '../helpers/ModalCarregarCargosHelper'
import { FileModel, ISelectModel } from '../../../../modules/services/core/_models'
import { useEffect, useState } from 'react'
import { useAuth } from '../../../../modules/auth'

type Props = {
    isConsultoria: boolean
    empresasCliente: ISelectModel[]
    abrirModal: boolean
    setAbrirModal: Function
}

const ModalCarregarCargos = ({abrirModal, setAbrirModal, isConsultoria, empresasCliente}: Props) => {
    
    const httpClient = useHttpClient()
    const alert = useAlert()
    const helper = useHelper()
    const { auth } = useAuth()
    const [modelos, setModelos] = useState([] as any[])
    const [idEmpresaClienteSelecionada, setIdEmpresaClienteSelecionada] = useState<number>(0)
    
    const formik = useFormik({
        initialValues: defaultCarregarCargos,
        validationSchema: auth?.servico.moduloDescricaoConfig.ativo ? modeloValidationSchema : defaultValidationSchemas,
        onSubmit: async (values, actions) => {

            alert.createDialog({
                html: `Realmente deseja carregar esses cargos?`,
                confirmAction: async () => {
                    
                    const response = await httpClient.request({
                        method: RequestMethod.POST, 
                        endpoint: `/Gerenciamento/Cargo/Carregar`,
                        queryObject: {
                            isConsultoria: isConsultoria,
                            idEmpresa: idEmpresaClienteSelecionada
                        },
                        data: values,
                        ifSuccessRedirectTo: '/conta/uploads',
                    })
                    
                    if (response.success) {
                        setAbrirModal(false)
                    }

                }
            })
    
        },
    })

    const filesHandler = async (files: Dropzone.DropzoneFile[]) => { 
        if(files && files.length > 0){

            const file = files[0]
            const base64 = await helper.convertFileToBase64(file)
            
            formik.setFieldValue('Arquivo', {
                Nome: file.name,
                Extensao: file.name.split('.').pop(),
                Tamanho: file.size,
                Tipo: file.type,
                Base64: base64
            })

        }
        else formik.setFieldValue('Arquivo', undefined)
    }

    const onClickBaixarModeloCarregar = async () => { 
        
        const response = await httpClient.request({
            method: RequestMethod.GET, 
            endpoint: `/Gerenciamento/Cargo/BaixarModeloCarregar`
        })
        
        if (response.success && response.payload) {
            const file: FileModel = response.payload
            await helper.downloadFile(file)
        }

    }

    const loadModelos = async () => {
        if(formik.values.IdModelo) formik.setFieldValue('IdModelo', undefined)
        setModelos([])
        const response = await httpClient.request({
            method: RequestMethod.GET,
            endpoint: '/Gerenciamento/Modelo/Obter',
            queryObject: {
                isConsultoria: isConsultoria,
                idEmpresa: idEmpresaClienteSelecionada
            },
        })

        if(response.success && response.payload){
            setModelos(response.payload)
        }
    }

    useEffect(() => {
        if(auth?.servico?.moduloDescricaoConfig.ativo) loadModelos()
    },[idEmpresaClienteSelecionada])

    return (
    <div className={`modal show fade`} tabIndex={-1} id="kt_modal_1" style={{display: "block"}}>
        <div className="modal-dialog modal-dialog-centered modal-xl">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title">Carregar cargos</h5>
                    <div
                    onClick={() => setAbrirModal(false)}
                    className="btn btn-icon btn-sm btn-active-light-primary ms-2"
                    data-bs-dismiss="modal"
                    aria-label="Fechar"
                    >
                    <KTSVG
                        path="/media/icons/duotune/arrows/arr061.svg"
                        className="svg-icon svg-icon-2x"
                    />
                    </div>
                </div>
                <div className="modal-body">
                    
                    <FormikProvider value={formik}>
                        <div className='w-100'>
                            <div className="row">

                                {(isConsultoria) && (
                                    <>
                                        <div className='col-lg-12 fv-row mb-10'>
                                            <label className='form-label required'>Cliente</label>
                                            <select
                                                className='form-select form-select-lg form-select-solid'
                                                value={idEmpresaClienteSelecionada}
                                                onChange={(e: React.ChangeEvent<HTMLSelectElement>) => { setIdEmpresaClienteSelecionada(parseInt(e.target.value)) }}
                                            >
                                            <option value={0}>Selecione...</option>
                                            {empresasCliente && empresasCliente.length > 0 && empresasCliente.map((data: ISelectModel, index: number) => {
                                                return (
                                                    <option key={`cliente-option-${index}`} value={data.Id}>
                                                    {data.Nome}
                                                    </option>
                                                )
                                            })}
                                            </select>
                                        </div>
                                    </>
                                )} 

                                {auth?.servico?.moduloDescricaoConfig.ativo && (
                                    <div className='col-lg-12 fv-row mb-10'>
                                            <label className='form-label required'>Modelo de formulário</label>
                                            <Field as='select' name={'IdModelo'} className='form-select form-select-lg form-select-solid' value={formik.values.IdModelo}>
                                                <option value=''>Selecione...</option>
                                                {modelos.map((data: any, index: any) => {
                                                    return <option key={`modelo-${index}`} value={data.Id}>{data.Nome}</option>
                                                })}
                                            </Field>
                                            <div className='text-danger mt-2'>
                                            <ErrorMessage name='IdModelo' />
                                        </div>
                                    </div>
                                )}

                                <div className='col-lg-12 fv-row mb-10'>
                                    <div className='notice d-flex bg-light-warning rounded border-warning border border-dashed p-6'>
                                        <KTSVG
                                        path='/media/icons/duotune/general/gen044.svg'
                                        className='svg-icon-2tx svg-icon-warning me-4'
                                        />
                                        <div className='d-flex flex-stack flex-grow-1'>
                                        <div className='fw-bold'>
                                            <div className='fs-6 text-gray-600'>
                                            Clique no botão abaixo para baixar o modelo e preencha os dados na coluna correta sem alterar os nomes das colunas ou da planilha, depois carregue o arquivo novamente
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='col-lg-12 fv-row mb-10 d-flex justify-content-center'>
                                    <button
                                        type='button'
                                        className='btn btn-lg btn-light-primary'
                                        onClick={onClickBaixarModeloCarregar}
                                    >
                                        <i className="fas fs-1 me-1 fa-file-download"></i>
                                        Baixar modelo
                                    </button>
                                </div>

                                <div className='col-lg-12 fv-row'>
                                    <DropzoneComponent 
                                        filesHandler={filesHandler}
                                        id='dz-carregar-cargos'
                                        preloadFiles={formik.values.Arquivo}
                                        options={{ 
                                            dictDefaultMessage: 'Arraste e solte o arquivo .xlsx do modelo preenchido com os dados ou clique aqui para procurar',
                                            acceptedFiles: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                                            maxFiles: 1,
                                            maxFilesize: 2
                                        }}
                                    />
                                    <div className='text-danger mt-2'>
                                        <ErrorMessage name='Arquivo' />
                                    </div>
                                </div>

                            </div>

                        </div>
                    </FormikProvider>
                </div>
                <div className="modal-footer">
                    <button
                        onClick={() => setAbrirModal(false)}
                        type="button"
                        className="btn btn-light me-5"
                        data-bs-dismiss="modal"
                    >
                        Cancelar
                    </button>
                    
                    <button type='button' onClick={() => formik.handleSubmit()} className={`btn btn-primary`}>
                        Carregar
                    </button>

                </div>
            </div>
        </div>
    </div>
  )
}

export {ModalCarregarCargos}